import React, { PureComponent } from 'react';
import { DeviceType } from '../../containers/rtc/DeviceManagerContext';
import { T, tFunctionType } from 'app/components/localization';
import MessageModal from './MessageModal';
import WithSkip from 'app/components/DeviceSetup/WithSkip';

const messagesPerType = {
  [DeviceType.Audio]: (t: tFunctionType) => ({
    title: t('rtc.device-setup.make-readable.audio.title'),
    message: t('rtc.device-setup.make-readable.audio.message'),
  }),
  [DeviceType.Video]: (t: tFunctionType) => ({
    title: t('rtc.device-setup.make-readable.video.title'),
    message: t('rtc.device-setup.make-readable.video.message'),
  }),
};

interface IProps {
  type: DeviceType;
}

class MakeDeviceReadable extends PureComponent<IProps> {
  public render() {
    const { type } = this.props;

    return (
      <T>{t => {
        const { title, message } = messagesPerType[type](t);

        return (
          <MessageModal
            title={title}
            buttons={<WithSkip type={type} />}
          >
            {message}
          </MessageModal>
        );
      }}</T>
    );
  }
}

export default MakeDeviceReadable;
